import { useId } from "react";
import { assetUrl } from "../../utils/assetUrl";
import reminderShell from "../../assets/parcel-reminder-shell.svg?raw";
import "./ParcelDayReminderCard.css";

interface ParcelDayReminderCardProps {
  title?: string;
  description?: string;
  onIgnore: () => void;
}

export function ParcelDayReminderCard({
  title = "快递助手",
  description,
  onIgnore
}: ParcelDayReminderCardProps) {
  const titleId = useId();
  const descriptionId = useId();
  const content = (
    <>
      <img className="parcel-day-reminder-card__icon" src={assetUrl("assets/figma/night-ai/generated-icons/scenario-package.png")} alt="" draggable={false} />
      <div className="parcel-day-reminder-card__copy">
      <span className="parcel-day-reminder-card__title" id={titleId} title={title}>
        {title}
      </span>
      {description ? <span className="parcel-day-reminder-card__description" id={descriptionId} title={description}>
        {description}
      </span> : null}
      </div>
    </>
  );

  return (
    <section className="parcel-day-reminder-card" aria-labelledby={titleId}>
      <div className="parcel-day-reminder-card__shell" aria-hidden="true" dangerouslySetInnerHTML={{ __html: reminderShell }} />
      <div className="parcel-day-reminder-card__content" aria-describedby={description ? descriptionId : undefined}>{content}</div>
      <button type="button" className="parcel-day-reminder-card__ignore" onClick={onIgnore}>
        忽略
      </button>
    </section>
  );
}
